/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import RadixTable from "../../Component/RadixTable";
import { Heading, Tabs, Table } from "@radix-ui/themes";
import PaginationBar from "../../Component/PaginationBar";
import { GeneralContextFunc } from "../../Context/GeneralContex";
import { getSourceList } from "../../Services/DashboardApi";
import { useNavigate } from "react-router-dom";
const header = ["Author", "Phone", "Street Address","City", "Campaign title", "Status"];

const Sources = () => {
  const navigate = useNavigate();
  const { setloader, initAlert } = GeneralContextFunc();
  const [listStatus, setListStatus] = useState("Charity");
  const [currentPage, setCurrentPage] = useState(1);
  const [sourceList, setSourceList] = useState([]);
  const itemsPerPage = 10;
  const totalItems = sourceList.length; // Example total items
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const getData = (payload) => {
    getSourceList(payload)
      .then((res) => {
        let data = [...res?.data?.sourceData];
        setSourceList([
          ...data.map((elem) => ({
            id: elem?.id,
            cellData: [
              elem?.name,
              elem?.phone,
              elem?.exactAddress,
              elem?.location,
              elem?.title,
              elem?.isCampaignStop ? "Not Active" : "Active",
            ],
          })),
        ]);
        // initAlert(res?.message);
        setloader(false);
      })
      .catch((err) => {
        setloader(false);
        if (err.response.data.error === "jwt expired") {
          initAlert("Your session is expired", "info");
          navigate("/");
          return;
        }
        console.log("error", err);
        initAlert(err?.response?.data?.message ?? "Error", "error");
      });
  };

  useEffect(() => {
    setloader(true);
    setCurrentPage(1);
    let payload = {
      page: 1,
      limit: itemsPerPage,
      body: { resourceName: listStatus },
    };

    getData(payload);
  }, [listStatus]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setloader(true);
    let payload = {
      page: pageNumber,
      limit: itemsPerPage,
      body: { resourceName: listStatus },
    };

    getData(payload);
  };

  const tableBodyData = sourceList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <>
      <Heading align="left" mt="5" ml="5">
        Source
      </Heading>
      <Tabs.Root value={listStatus} mx="5" mt="5">
        <Tabs.List color="gray" highContrast>
          <Tabs.Trigger
            onClick={() => setListStatus("Charity")}
            value="Charity"
          >
            Charities
          </Tabs.Trigger>
          <Tabs.Trigger
            onClick={() => setListStatus("Small Business")}
            value="Small Business"
          >
            Business
          </Tabs.Trigger>
          <Tabs.Trigger
            onClick={() => setListStatus("Local Community")}
            value="Local Community"
          >
            Communities
          </Tabs.Trigger>
        </Tabs.List>
      </Tabs.Root>
      {/* <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-start",
          margin: "24px 24px",
        }}
      >
        <Button size="3">Add source</Button>
      </div> */}
      <Table.Root variant="surface" size="3" mx="5" layout="auto">
        <RadixTable header={header} data={tableBodyData} routeUrl={"/"} />
      </Table.Root>
      {sourceList.length > 10 && (
        <PaginationBar
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </>
  );
};

export default Sources;
